import React, { useEffect } from "react";
import {
	Container,
	Grid,
  GridColumn,
  GridRow,
  Header,
  Image,
} from "semantic-ui-react"
import Faq from "./faq";

export default function ContactUs() {
  useEffect(() => {
    document.title = "Splinters Woodwork | Contact Us"
  }, []);

  const h1Style = {
    fontFamily: "'Andika', sans-serif",
    color: "#8C8C8C",
		fontSize: "4em",
  }

	const h1StyleMobile = {
    fontFamily: "'Andika', sans-serif",
    color: "#8C8C8C",
		fontSize: "3em",
  }

  const h1WhiteStyle = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
		fontSize: "4em",
  }

	const h1WhiteStyleMobile = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
		fontSize: "3em",
  }

  const pStyle = {
    fontFamily: "'Andika', sans-serif",
    color: "#8C8C8C",
		fontSize: "1.1em",
  }

  return(
    <div>
      <Grid 
        style={{ 
          backgroundColor: "#C2CDBE",
          margin: "-12em 0em 0em 0em", 
          padding: "12em 0em 5em 0em",
        }}
      >
				<GridRow columns={1} style={{ padding: "0em 0em 4em 0em" }}>
					<GridColumn only="computer tablet" textAlign='center'>
						<Header
							as='h1'
              id="contact-header"
							content='Contact Us'
							style={h1WhiteStyle}
						/>
					</GridColumn>
					<GridColumn only="mobile" textAlign='center'>
						<Header
							as='h1'
              id="contact-header"
							content='Contact Us'
							style={h1WhiteStyleMobile}
						/>
					</GridColumn>
				</GridRow>
      </Grid>

      <Grid>  
        <GridRow 
          style={{
            padding: "0em 0em 0em 0em", 
            margin: "-1em 0em 0em 0em", 
          }}
        >
          <GridColumn>
            <Image
              src="./bottomBreak.svg"
              alt="Decorative bottom break"
            />
          </GridColumn>
        </GridRow>
			</Grid>

      <Grid style={{ padding: "10em 0em 10em 0em" }}>
        <GridRow>
          <GridColumn>
            <Container textAlign="center" style={pStyle}>
              Email: <a href="mailto:splinterswoodwork@gmail.com" style={pStyle}>splinterswoodwork@gmail.com</a>
            </Container>
            <br/>
            <Container textAlign="center" style={pStyle}>
              Phone: Call Judy on <a href="tel:+61488046638" style={pStyle}>(+61) 488 046 638</a> or call John on <a href="tel:+61409540009" style={pStyle}>(+61) 409 540 009</a>
            </Container>
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow only="computer tablet">
          <GridColumn textAlign="center">
            <Header
              as="h2"
              id="faq-header"
              content="Frequently Asked Questions"
              style={h1Style}
            />
          </GridColumn>
        </GridRow>
        <GridRow only="mobile">
          <GridColumn textAlign="center">
            <Header
              as="h2"
              id="faq-header"
              content="Frequently Asked Questions"
              style={h1StyleMobile}
            />
          </GridColumn>
        </GridRow>

        <GridRow>
          <GridColumn>
            <Faq/>
          </GridColumn>
        </GridRow>
      </Grid>
    </div>
  )
}